import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Liste de rôles autorisés. Si omise, tout utilisateur connecté est admis. */
  rolesAutorises?: string[];
}

export function ProtectedRoute({ children, rolesAutorises }: ProtectedRouteProps) {
  const { session, profil, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Chargement…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (rolesAutorises && profil && !rolesAutorises.some((r) => profil.roles.includes(r))) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 px-4 text-center">
        <h1 className="text-xl font-semibold">Accès refusé</h1>
        <p className="text-sm text-muted-foreground">
          Vous n'avez pas les droits nécessaires pour accéder à cette page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
